import { currencies } from '../content/supportedCurrencies'

export default function getCurrencySymbol(currencyCode) {
	if (typeof currencyCode !== 'string') return currencyCode
	const code = currencyCode.toUpperCase()
	if (!currencies.hasOwnProperty(code)) return currencyCode
	return currencies[code]
}


// WEBPACK FOOTER //
// ./src/utilities/currency/getCurrencySymbol.js